import { render, staticRenderFns } from "./ModalityPermissionsModal.vue?vue&type=template&id=0e54fe20"
import script from "./ModalityPermissionsModal.vue?vue&type=script&lang=js"
export * from "./ModalityPermissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports